import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { focusVisible } from '@space-core/styles'
import clsx from 'clsx'
import styled from 'styled-components'

import Icon from '../icon'

const BtnContainer = styled.button`
  background: 0;

  &:hover {
    text-decoration: underline;
  }

  ${focusVisible}
`

export type SeeAllProps = {
  text: string
  onClick?: () => void
  className?: string
}

const SeeAll = ({ text, onClick, className }: SeeAllProps) => {
  const seeAllClassName = clsx(
    '_d-flex _align-items-center _border-0 _cursor-pointer _text-1 _text-gray-900',
    className
  )

  return (
    <BtnContainer data-test='see-all-btn' className={seeAllClassName} onClick={onClick}>
      <span>{text}</span>
      <Icon icon={faArrowRight} className='_ml-2' data-test='see-all-icon' />
    </BtnContainer>
  )
}

export default SeeAll
